import { Outlet } from 'react-router-dom'
import Sidebar from './Sidebar.jsx'
import Topbar from './Topbar.jsx'
import GlobalSearchIndicator from '../prospects/GlobalSearchIndicator.jsx'
import AnnouncementsGate from '../announcements/AnnouncementsGate.jsx'
import WorkerJobsWatcher from '../WorkerJobsWatcher.jsx'
import GmailConnectResult from '../communication/GmailConnectResult.jsx'

export default function DashboardLayout() {
  return (
    <div className="dashboard-container">
      <Sidebar />
      <div className="main-content">
        <Topbar />
        <main className="dashboard-content">
          <Outlet />
        </main>
      </div>
      <GlobalSearchIndicator />
      <AnnouncementsGate />
      <WorkerJobsWatcher />
      <GmailConnectResult />
    </div>
  )
}
